import React, { useMemo } from 'react';
import { SummaryCard, formatCurrency } from './InventoryUIKit';
import { Package, TrendingDown, IndianRupee, Wallet, Layers } from 'lucide-react';

const formatQty = (n) => Number(n).toLocaleString('en-IN');

const PurchaseSummaryCards = ({ batches, loading, error }) => {
  const stats = useMemo(() => {
    if (!batches || batches.length === 0) {
      return {
        totalPurchaseQty: 0,
        totalRemainingQty: 0,
        totalPurchaseAmount: 0,
        totalRemainingValue: 0,
        totalBatches: 0,
      };
    }
    let totalPurchaseQty = 0;
    let totalRemainingQty = 0;
    let totalPurchaseAmount = 0;
    let totalRemainingValue = 0;

    for (let i = 0; i < batches.length; i++) {
      const b = batches[i];
      totalPurchaseQty += Number(b.purchase_quantity) || 0;
      totalRemainingQty += Number(b.quantity_remaining) || 0;
      totalPurchaseAmount += Number(b.total_purchase_value) || 0;
      totalRemainingValue += Number(b.remaining_value) || 0;
    }

    return {
      totalPurchaseQty,
      totalRemainingQty,
      totalPurchaseAmount,
      totalRemainingValue,
      totalBatches: batches.length,
    };
  }, [batches]);

  const iconStyle = (color) => ({
    fontSize: '22px',
    color,
  });

  const cards = [
    {
      title: 'Total Purchase Qty',
      value: `${formatQty(stats.totalPurchaseQty)} Units`,
      icon: <Package style={iconStyle('#6366f1')} />,
      accentColor: '#6366f1',
      loading,
      error,
    },
    {
      title: 'Remaining Qty',
      value: `${formatQty(stats.totalRemainingQty)} Units`,
      icon: <TrendingDown style={iconStyle('#11a8a4')} />,
      accentColor: '#11a8a4',
      loading,
      error,
    },
    {
      title: 'Total Purchase Amount',
      value: formatCurrency(stats.totalPurchaseAmount),
      icon: <IndianRupee style={iconStyle('#7ed957')} />,
      accentColor: '#7ed957',
      loading,
      error,
    },
    {
      title: 'Remaining Inventory Value',
      value: formatCurrency(stats.totalRemainingValue),
      icon: <Wallet style={iconStyle('#f59e0b')} />,
      accentColor: '#f59e0b',
      loading,
      error,
    },
    {
      title: 'Purchase Batches',
      value: `${stats.totalBatches} Batches`,
      icon: <Layers style={iconStyle('#9440dd')} />,
      accentColor: '#9440dd',
      loading,
      error,
    },
  ];

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginBottom: '24px' }}>
      {cards.map((c, i) => (
        <SummaryCard key={i} {...c} />
      ))}
    </div>
  );
};

export default React.memo(PurchaseSummaryCards);
